





















































import { Component, Prop } from "vue-property-decorator";

import { DialogSection, DialogForm, FormText } from "sitewhere-ide-components";
import { VFlex } from "vuetify/lib";

import { IMetadataCoapParameterExtractorConfiguration } from "sitewhere-configuration-model";

import { required } from "vuelidate/lib/validators";

@Component({
  components: { VFlex, DialogSection, DialogForm, FormText },
  validations: {
    hostnameMetadataField: {
      required
    },
    portMetadataField: {
      required
    },
    urlMetadataField: {
      required
    },
    methodMetadataField: {
      required
    }
  }
})
export default class MetadataCoapParameterExtractorFields extends DialogSection {
  @Prop() readonly tenantId!: string;

  hostnameMetadataField: string | null = null;
  portMetadataField: string | null = null;
  urlMetadataField: string | null = null;
  methodMetadataField: string | null = null;

  /** Reset section content */
  reset(): void {
    this.hostnameMetadataField = null;
    this.portMetadataField = null;
    this.urlMetadataField = null;
    this.methodMetadataField = null;
    this.$v.$reset();
  }

  /** Perform validation */
  validate(): boolean {
    this.$v.$touch();
    return !this.$v.$invalid;
  }

  /** Load form data from an object */
  load(input: IMetadataCoapParameterExtractorConfiguration): void {
    this.hostnameMetadataField = input.hostnameMetadataField || "coap_hostname";
    this.portMetadataField = input.portMetadataField || "coap_port";
    this.urlMetadataField = input.urlMetadataField || "coap_url";
    this.methodMetadataField = input.methodMetadataField || "coap_method";
  }

  /** Save form data to an object */
  save(): IMetadataCoapParameterExtractorConfiguration {
    return {
      hostnameMetadataField: this.hostnameMetadataField || "",
      portMetadataField: this.portMetadataField || "",
      urlMetadataField: this.urlMetadataField || "",
      methodMetadataField: this.methodMetadataField || ""
    };
  }
}
